export default "__VITE_ASSET__BH3N5FUP__"